<div class="room-item-percent">
    <div class="room-item-percent__description">{{ titleDescription }}</div>
    <div class="room-item-percent__grade-description">{{ gradeDescription }}</div>
    <div class="room-item-percent__title">{{ title }}</div>
    <div class="room-item-percent__grade">
        {{ grade }}
        <span class="room-item-percent__grade-symbol"> %</span>
    </div>
</div>
